import BuddyForm from './BuddyForm';

export default BuddyForm;
